/**
  * THIS IS A GENERATED FILE. DO NOT ALTER DIRECTLY.
  */

 ;
import type { SVGProps } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgColorPicker = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path fill="currentColor" fillRule="evenodd" d="M18.707 3.15q-1.06-1.059-2.121 0l-3.182 3.183-1.06-1.06-1.061 1.06 1.06 1.06-8.132 8.132-.883 3.359 1.06 1.06 3.359-.883 8.132-8.132 1.06 1.06L18 10.93l-1.06-1.06 3.181-3.183q1.06-1.06 0-2.12zm-5.303 5.304 1.414 1.414-7.845 7.845-1.92.505.506-1.919z" clipRule="evenodd" /></svg>;
export default SvgColorPicker;